import React from 'react';
function Searches(){

    return (
       
        <>
         

<span class="search-box">
<input class="search-txt" type="text" name="" placeholder="Type to search..." />
<a class="search-btn" href="#">
<span className="material-symbols-rounded ">search</span>
</a>

</span>
         
        </>
    )
}

export default Searches;